module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.state == 'OK') ? _c(_vm.currentView, {
    tag: "component"
  }) : (_vm.state == 'ERROR') ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : (_vm.state == 'LOADING') ? _c('loading', {
    attrs: {
      "text": "loading template..."
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c25ec428!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ResourceTemplate.vue
// module id = 1552
// module chunks = 2